import { Anchor, Group, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const ArgumentsCampaign = ({ item }) => {
  const lang = useLanguage((s) => s.language);

  let list = {
    contacted: lang.statistics.contacts_type.contacted,
    sent_today: lang.statistics.contacts_type.sent_today,
    opener: lang.statistics.contacts_type.opener,
    clicker: lang.statistics.contacts_type.clicker,
    answerer: lang.statistics.contacts_type.answerer,
    unsubscriber: lang.statistics.contacts_type.unsubscriber,
    bounced: lang.statistics.contacts_type.bounced,
    to_contact: lang.statistics.contacts_type.to_contact,
    blacklisted: lang.statistics.contacts_type.blacklisted,
    excluded_previous_programmation:
      lang.statistics.contacts_type.excluded_previous_programmation,
    excluded_workflow: lang.statistics.contacts_type.excluded_workflow,
    to_contact_failed: lang.statistics.contacts_type.to_contact_failed,
  };

  return (
    <Group>
      <Text>{lang.routes.stats.contacts_of}: </Text>
      <Anchor
        href={`/statistics/campaigns/${item.arguments.programmationId}/workflow/${item.arguments?.workflowId}/step/${item.arguments?.stepId}/contacts/contacted/${item.arguments?.contactType}`}
        target="_blank"
        fw={500}
        truncate="end"
      >
        #{item?.arguments?.programmationId} -{" "}
        {list[item.arguments?.contactType] || item.arguments?.contactType},{" "}
        {lang.campaigns.step} #{item.arguments?.stepId}
      </Anchor>
    </Group>
  );
};

export default ArgumentsCampaign;
